import { render, staticRenderFns } from "./SplitPane.vue?vue&type=template&id=22197e0c&scoped=true&"
import script from "./SplitPane.vue?vue&type=script&lang=js&"
export * from "./SplitPane.vue?vue&type=script&lang=js&"
import style0 from "./SplitPane.vue?vue&type=style&index=0&id=22197e0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22197e0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22197e0c')) {
      api.createRecord('22197e0c', component.options)
    } else {
      api.reload('22197e0c', component.options)
    }
    module.hot.accept("./SplitPane.vue?vue&type=template&id=22197e0c&scoped=true&", function () {
      api.rerender('22197e0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/components/SplitPane.vue"
export default component.exports